import { useRef, type ReactNode } from 'react'
import { useFitScale } from '@/hooks/useFitScale'

interface Props {
  children: ReactNode
  className?: string
  /** Remeasure when mode changes (chart vs detail form). */
  modeKey?: string | number | boolean
  minScale?: number
}

/**
 * Shrinks children (CSS zoom) so they fit the available pane without clipping.
 */
export function FitScalePane({ children, className = '', modeKey, minScale }: Props) {
  const viewportRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)
  const { style } = useFitScale({
    viewportRef,
    contentRef,
    modeKey,
    minScale,
  })

  return (
    <div ref={viewportRef} className={`fit-scale${className ? ` ${className}` : ''}`}>
      <div ref={contentRef} className="fit-scale__content" style={style}>
        {children}
      </div>
    </div>
  )
}
